import { Alert } from '@cmsgov/ds-medicare-gov';
import { useEffect } from 'react';
import '../css/validation.alert.css';
import { Link } from 'react-router-dom';
import the from '../../common/objects/the';
import translate from '../../common/functions/translate';
import TranslatedSpan from './translated.span';
import { getChatUrl } from '../functions/get.chat.url';

interface ApiErrorAlertProps {
    errorMessage: string | null
    alreadyUnlocked?: boolean
    nestedErrorMessage?: JSX.Element | string | null
    deactiveAccount?: boolean
}

const ApiErrorAlert = (props: ApiErrorAlertProps) => {

    // make sure scrolled into view when error message changes
    useEffect(() => {
        if (props.errorMessage) {
            const [alertEl] = document.querySelectorAll('.ds-c-alert');
            if (alertEl) {
                alertEl.scrollIntoView();
            }
        }
    }, [props.errorMessage]);

    if (!props.errorMessage)
        return null;
    return <>
        <Alert
            headingId={'alertHeader'}
            hideIcon={true}
            role={'alert'}
            variation={'error'}
        >
            <TranslatedSpan english={'Error'}/>: {props.errorMessage}
            {props.nestedErrorMessage && !props.deactiveAccount &&
            <Link style={{
                color: the.color.tarheelBlue,
                fontSize: 16
            }}
            to="/unlock-account">
                {props.nestedErrorMessage}.
            </Link>
            }
            {!props.nestedErrorMessage && props.deactiveAccount &&
         <>
             <a href={getChatUrl()}>{translate('chat with us')}</a> {translate('or call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048.')}
         </>
            }
            {props.alreadyUnlocked && <>
                {' '}<Link to="/login">{translate('Log in')}</Link> {translate('now to start using your account.')}
            </>}
        </Alert>
    </>;
};

export default ApiErrorAlert;

